import { createRouter, createWebHashHistory } from 'vue-router'
import Home from './routes/home'
import route from './routes/route'//路线
import consumerAccount from './routes/consumerAccount'//消费账户

//路由列表
const routes = new Array().concat(route).concat(consumerAccount);
/*//消费账户
const consumerAccounts = new Array().concat(Home).concat(consumerAccount);*/
//创建路由 实例
export default createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
  /*consumerAccounts*/
})
